import { Link } from "react-router-dom";

const mission = [
  { verb: "Educate", rest: "people with aphasia (PWA)" },
  { verb: "Empower", rest: "PWA to use technology to improve communication skills" },
  { verb: "Promote", rest: "peer-befriending" },
  { verb: "Develop", rest: "a national PWA community" },
  { verb: "Encourage", rest: "optimism and positive outlook in PWA" },
];

// Two peers, arms raised together
const PeersGraphic = () => (
  <svg viewBox="0 0 240 200" className="page-graphic__svg" role="img" aria-label="Two people holding hands">
    <g fill="none" stroke="#2d4593" strokeWidth="9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="72" cy="34" r="18" />
      <circle cx="168" cy="34" r="18" />
      {/* bodies */}
      <path d="M72 58 L72 120 M72 120 L58 186 M72 120 L86 186" />
      <path d="M168 58 L168 120 M168 120 L154 186 M168 120 L182 186" />
      {/* outer arms raised */}
      <path d="M72 72 L30 46" />
      <path d="M168 72 L210 46" />
      {/* inner arms joined */}
      <path d="M72 76 L120 104 L168 76" />
    </g>
  </svg>
);

export default function AboutNAS() {
  return (
    <div className="page">
      <h1 className="page-title">About NAS</h1>

      <div className="page-split">
        <div className="page-split__text">
          <p>
            National Aphasia Synergy (NAS) is a peer-led non-profit organization designed to
            support people with aphasia. NAS was founded by—and will be guided by—people with
            aphasia. The National Aphasia Synergy philosophy is for people with aphasia to help
            other people with aphasia thrive.
          </p>

          <h2 className="section-title">Mission Statement</h2>
          <p>NAS is a peer-led community of people with aphasia developed to:</p>
          <ul className="plain-list">
            {mission.map(({ verb, rest }) => (
              <li key={verb}>
                <strong>{verb}</strong> {rest}
              </li>
            ))}
          </ul>

          <h2 className="section-title">Vision Statement</h2>
          <p>
            The NAS vision is that one day, the population of the United States will have a greater
            understanding of aphasia, and as a result, all people with aphasia will be treated with
            respect and kindness.
          </p>

          <Link to="/about/team" className="btn-outline">Meet the Team →</Link>
        </div>

        <div className="page-split__media page-graphic">
          <PeersGraphic />
        </div>
      </div>
    </div>
  );
}
